import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { Button, IconButton, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopy, Report } from '@material-ui/icons';
import { handleLoadBatchIdDialog, handleSaveDispatchHistoryDialog, showAlertSnackbar } from '../../../reducers/uiSlice';
import { useTranslation } from 'react-i18next';
import { useToken } from "../../../utilities/hooks";

const useStyles = makeStyles((theme)=> ({
    container: {
        paddingBottom: 10
    },
    batchAction: {
        justifyContent: 'flex-end',
        paddingBottom: 10
    },
    batchInfo: {
        justifyContent: 'space-between'
    },
    row: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
    }
}))

const SELECT_BATCHES = 1;

function BatchInfo(props){
    const classes = useStyles();
    const {t} = useTranslation('mapManagement');
    const dispatch = useDispatch();
    const tokenContents = useToken();

    const userHasSelectBatches = tokenContents.uiAbilities.includes(SELECT_BATCHES);

    return (
        <div className={classes.container}>
            <div className={`${classes.row} ${classes.batchAction}`}>
                <div style={{display: 'flex', flexDirection: 'row', flexGrow: 1}}>
                    { props.selectedBatchIds.length <= 0 ? <Report color='error' style={{marginRight: 12}}/> : null}
                    <Tooltip title={props.selectedBatchIds.toString()}>
                        <Typography>{displayBatches(props.selectedBatchIds)}</Typography>
                    </Tooltip>
                    { props.selectedBatchIds.length > 0 ?
                        <Tooltip title='Copy Batch References'>
                            <IconButton aria-label="copy-batch-ids" size="small" onClick={()=>{handleCopyBatchIds(props.selectedBatchIds)}}>
                                <FileCopy fontSize="inherit"/>
                            </IconButton>
                        </Tooltip>
                        : null}
                </div>
                {
                    userHasSelectBatches ?
                        <div>
                            {
                                props.selectedBatchIds.length > 0 ?
                                    <Button onClick={_handleSaveDispatchHistory}>{t('common:save')}</Button>
                                    :
                                    null
                            }
                            <Button
                                onClick={()=>dispatch(handleLoadBatchIdDialog(true))}
                            >
                                {t('common:load')}
                            </Button>
                        </div>
                        :
                        null
                }

            </div>
            <div className={`${classes.row} ${classes.batchInfo}`}>
                <Typography variant="caption">{t('total_orders_amount')}: {props.batchInfo.total || "N/A"}</Typography>
                <Typography variant="caption">{t('not_delivered_amount')}: {props.batchInfo.undelivery || "N/A"}</Typography>
                <Typography variant="caption">{t('not_scanned_amount')}: {props.batchInfo.unscan || "N/A"}</Typography>
                <Typography variant="caption">{t('scan_progress_percent')}: {calculateScanProgress(props.batchInfo.total, props.batchInfo.unscan, 2)}</Typography>
            </div>
            <div className={`${classes.row} ${classes.batchInfo}`}>
                <Typography variant="caption">{t('parcel_scanned_ratio')}: {calculateProgress(props.batchInfo.total, props.batchInfo.scanned, 2)}</Typography>
                <Typography variant="caption">{t('gateway_transit_ratio')}: {calculateProgress(props.batchInfo.total, props.batchInfo.gatewaytransit, 2)}</Typography>
            </div>
        </div>
    )

    function displayBatches(batchIds){
        if(batchIds.length <= 0) {
            return t('no_batch_selected')
        } else if (batchIds.length == 1) {
            return batchIds[0]
        } else {
            return `${t('multiple_batches_selected')} (${batchIds.length})`
        }
    }

    function calculateProgress(total, num, toFixed) {
        if(isNaN(total)){
            return "N/A"
        }
        return `${((num/total)*100).toFixed(toFixed)}%`
    }

    function calculateScanProgress(total, notScanned, toFixed){
        if(isNaN(total) || isNaN(notScanned)){
            return "N/A"
        }
        return `${(((total - notScanned)/total)*100).toFixed(toFixed)}%`
    }

    function _handleSaveDispatchHistory(){
        dispatch(handleSaveDispatchHistoryDialog(true))
    }

    function handleCopyBatchIds(batchIds){
        navigator.clipboard.writeText(batchIds.toString())
        dispatch(showAlertSnackbar({title: 'Copy Batch', message: 'You have successfully copied batch referer ids!', type: 'success'}))
    }
}

BatchInfo.defaultProps = {
    selectedBatchIds: []
}


export default BatchInfo;